import React from "react";
import { getSpacingClassName } from "@qlik/qlik/src/lib/util/spacing";
import { renderRichText } from "gatsby-source-contentful/rich-text";
import formatContentfulRichText from "@qlik/qlik/src/lib/format-rich-text-content";
import ImageCard from "@qlik/qlik/src/components/Card/Single-Card-Image";
import { getColorClassName } from "@qlik/qlik/src/lib/util/colors";
import Cta from "@qlik/qlik/src/components/Cta";
import * as styles from "./styles.module.css";

/**
 * This file contains several components related to Image Cards.
 * It includes different variants of cards and their respective styles.
 * The main exported component is DeckImageCards which renders a deck of ImageCards.
 */

/**
 * DeckImageCards component.
 * Renders a deck of ImageCards with a title and optional CTAs.
 * @param {Object} props - The props for the DeckImageCards component.
 * @returns {JSX.Element} - The DeckImageCards component.
 */
const DeckCardWithFullImage = ({ data }) => {
    const { customId, cardItems, title, body, cta, additionalConfiguration, backgroundColor, id, numberOfColumns } =
        data ?? {};
    const { sectionColorMapping } = getColorClassName(backgroundColor);

    const titleColor = sectionColorMapping.primaryTextColor;
    const isImageFull = true;
    const bodyDescription = true;

    const sectionSpacingClassName = getSpacingClassName(additionalConfiguration, "lg:py-30");
    const cardGridClassName = title ? "mt-10 lg:mt-20" : "";
    return (
        <section
            id={customId ?? id}
            data-section
            className={` py-7.5 scroll-mt-45 ${sectionSpacingClassName} ${sectionColorMapping.bgColor}`}
        >
            <div className={`container ${styles.cardMainWrapper}`}>
                {title && <h2 className={`text-center lg:text-6xl ${titleColor}`}>{title}</h2>}
                {body && (
                    <div className={`mt-4.5 ${styles.cardBodyWrapper}`}>
                        {renderRichText(body, formatContentfulRichText())}
                    </div>
                )}
                <div
                    className={`grid gap-10 ${
                        numberOfColumns === null ? "md:grid-cols-3" : `md:grid-cols-${numberOfColumns}`
                    } lg:gap-7.5  ${cardGridClassName}`}
                >
                    {cardItems?.map((card) => (
                        <ImageCard
                            data={card}
                            key={card.id}
                            isGridTight={numberOfColumns && numberOfColumns > 3}
                            isImageFull={isImageFull}
                            bodyDescription={bodyDescription}
                        />
                    ))}
                </div>
                {cta && (
                    <div className=" pt-15 xl:pt-19.75">
                        {cta?.map((button) => (
                            <div className="flex mb-2.5 justify-center items-center" key={button.id}>
                                <Cta key={button.id} data={button} />
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </section>
    );
};

// Export the DeckCardWithFullImage component as default
export default DeckCardWithFullImage;
